// アコーディオン開閉
$('.c-accordion__parent').click(
  function(){
  $('.c-accordion__child__list').toggleClass('open');
});
$('.c-accordion__parent').click(
  function(){
  $('.c-accordion__parent').toggleClass('active');
});

// faq accordion
$('.faq__accordion__toogle').click(function(){
  $(this).next().slideToggle(150);
  $(this).next().toggleClass('open');
  $(this).toggleClass('open');
});



// モーダル
$(function(){
  $(".p-modal__trigger").each(function(){
    $(this).on('click',function(e){
      e.preventDefault();
      var target = $(this).data('target');
      var modal = document.getElementById(target);
      $(modal).find('.p-modal__wrapper').fadeIn(300);
      $('.p-modal__child').scrollTop(0);
      $('html, body').css('overflow', 'hidden');
    });
  });
  $('.p-modal__cancel, .p-modal__layer').on('click',function(){
    $('.p-modal__wrapper').fadeOut(300);
    $('html, body').removeAttr('style');
  });
});